import * as React from 'react';
import { Fragment } from '../../../../Shared/components/fragment';
import { PanelBody, PanelHeader } from '../../../components/panel';
import { SvgWrapper } from '../../../components/svg-wrapper';
import * as styles from './tax-deductible-funds-panel.less';

interface ITaxDeductibleFundsPanel {
	onViewFunds?: () => void;
}

export class TaxDeductibleFundsPanel extends React.Component<ITaxDeductibleFundsPanel> {
	handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		if (this.props.onViewFunds) {
			this.props.onViewFunds();
		}
	}

	render() {
		return (
			<Fragment>
				<PanelHeader>Tax deductible funds</PanelHeader>
				<PanelBody>
					Contributions to all tax deductible funds will be included in your statements.
					<a className={styles.link} href="javascript:void(0)" onClick={this.handleClick}>
						View funds
						<SvgWrapper svg="icon-chevron-right" width="14" height="14" />
					</a>
				</PanelBody>
			</Fragment>
		);
	}
}
